import React, { useEffect, useRef, useState } from 'react';
import { withTranslation } from "../../../i18n";
import AnalyticsService from "../../../services/utils/AnalyticsService";
import AdsService from "../../../services/utils/AdsService";
import CookiesService from "../../../services/utils/CookiesService";
import GTMService from "../../../services/utils/GTMService";
import Button from '../../button/simpleButton/Button';
import ManageCoookiesModal from "../ManageCookieModal/ManageCookieModal";
import css from './CookiesBanner.module.scss';

const namespacesRequired = ['cookie', 'common'];

const CookiesBanner = ({ t, setShowBanner }) => {

  const [showManageCookieModal, setShowManageCookieModal] = useState(false);
  const [isBannerActive, setIsBannerActive] = useState(null);
  const bannerRef = useRef(null);


    const declineSubmit = () => {
      setShowManageCookieModal(false);
      setIsBannerActive(false);
      localStorage.setItem('cookieBanner', 'enable');
      AnalyticsService.disableAnalyticsCookie();
      AdsService.disableAdsCookie();
      CookiesService.disableMarketingCookie();
      GTMService.sendEvent("consent_update");
    };

    const agreedSubmit = () => {
        setShowManageCookieModal(false);
        setIsBannerActive(false);
        localStorage.setItem('cookieBanner', 'enable');
        AnalyticsService.enableAnalyticsCookie();
        AdsService.enableAdsCookie();
        CookiesService.enableMarketingCookie();
        GTMService.sendEvent("consent_update");
    };

  useEffect(() => {
    setIsBannerActive((localStorage.getItem('cookieBanner') !== "enable"));
  }, [isBannerActive]);

  // The banner is fixed to the bottom of the viewport and nothing reserved its
  // height, so it sat on top of the last screenful of the page. On the footer
  // that meant the newsletter form was hidden behind it and clicks on the date
  // field and its calendar icon landed on the banner instead.
  useEffect(() => {
    const banner = bannerRef.current;
    if (!isBannerActive || !banner) return undefined;

    const reserveBannerHeight = () => {
      const height = `${banner.offsetHeight}px`;
      document.body.style.paddingBottom = height;
      // Keeps scrollIntoView and anchor jumps from parking their target under
      // the banner, which on mobile covers half the viewport.
      document.documentElement.style.scrollPaddingBottom = height;
    };

    reserveBannerHeight();
    const observer = typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(reserveBannerHeight)
      : null;
    observer?.observe(banner);
    window.addEventListener("resize", reserveBannerHeight);

    return () => {
      observer?.disconnect();
      window.removeEventListener("resize", reserveBannerHeight);
      document.body.style.paddingBottom = "";
      document.documentElement.style.scrollPaddingBottom = "";
    };
  }, [isBannerActive]);

  return (
    <React.Fragment>
      {isBannerActive && (
        <div className={css.banner} ref={bannerRef}>
          <ManageCoookiesModal visible={showManageCookieModal}
            onHide={() => {
              setShowManageCookieModal(false);
            }}
            onSubmit={() => {
              setShowManageCookieModal(false);
              setIsBannerActive(false);
              localStorage.setItem('cookieBanner', 'enable');
            }}
          />
          <p>
            <span dangerouslySetInnerHTML={{ __html: t('cookie:banner-desc.part-1') }} />
            <a style={{ cursor: "pointer" }} class='blue' onClick={() => setShowManageCookieModal(true)} dangerouslySetInnerHTML={{ __html: t('cookie:banner-desc.part-2') }} />
            <span dangerouslySetInnerHTML={{ __html: t('cookie:banner-desc.part-3', { link: "/static/pdf/PVP_M1L_JUILLET2026.pdf" }) }} />
          </p>

          <div className={css.flex_container}>
            <Button className={css.btn_white} onClick={() => setShowManageCookieModal(true)}>
              {t('cookie:manage')}
            </Button>
            <Button className={css.btn_white} onClick={() => declineSubmit()}>
              {t('cookie:decline')}
            </Button>
            <Button className={css.btn_white} onClick={() => agreedSubmit()}>
              {t('cookie:agree')}
            </Button>
          </div>
          <p style={{ color: "transparent", textAlign: "right", padding: 0 }}>Is not here</p>
        </div>
      )}
    </React.Fragment>


  );
};

export default withTranslation(namespacesRequired)(CookiesBanner);

